var _rect, _ellipse, _path, _path2, _path3, _path4, _ellipse2, _path5, _path6, _ellipse3, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.938477,
    y: 0.434814,
    width: 41.1086,
    height: 41.1085,
    rx: 6,
    fill: "#BFC2FF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.4925,
    cy: 20.9891,
    rx: 16.786,
    ry: 16.786,
    fill: "#543BEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3303 6.92031C13.2835 6.29841 14.3038 5.77076 15.3779 5.35059L18.4039 10.7085C18.4039 10.7085 18.3489 11.3969 17.3212 12.0821C16.2935 12.7672 15.4371 12.4213 15.4371 12.4213L12.3303 6.92031Z",
    fill: "#02006E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M12.9272 18.6252C12.9272 16.4327 14.7543 14.2859 15.6678 13.4866C16.8668 13.087 19.7444 12.6644 21.6628 14.1718C24.0608 16.0559 26.2875 20.8519 29.1994 21.537C31.8721 22.1659 33.5347 24.9594 26.902 30.1824C25.6169 31.1944 24.1887 32.0468 22.6222 32.5175C19.4243 33.4785 16.6537 33.2909 15.4965 33.0132C14.6401 32.8419 13.1328 31.8827 13.955 29.4162C14.9827 26.333 12.9272 21.3657 12.9272 18.6252Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7839 16.1938C13.7839 14.2952 15.154 12.4309 16.1145 11.4461C16.376 11.1781 16.7057 10.9882 17.0703 10.9027C18.4542 10.5784 20.85 10.4286 22.5195 11.7404C24.9175 13.6245 27.1442 18.4205 30.0561 19.1056C32.9679 19.7908 34.6808 23.0452 25.7739 29.2115C21.6631 31.1299 17.7806 30.9243 16.3532 30.5818C15.4968 30.4105 13.9895 29.4513 14.8116 26.9848C15.8394 23.9016 13.7839 18.9343 13.7839 16.1938Z",
    fill: "var(--color-primitives-primary-100)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4963 20.9899C13.989 16.879 14.7541 14.481 15.325 13.7959C14.9139 17.4957 17.8372 20.8757 19.436 22.1889C17.7916 23.0111 16.4099 24.8724 15.839 25.6146C16.5241 24.3813 15.896 22.0176 15.4963 20.9899Z",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.57374,
    cy: 3.45283,
    rx: 8.57374,
    ry: 3.45283,
    transform: "matrix(0.878154 -0.478378 0.47838 0.878153 14.6406 26.4521)",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7257 20.5389C31.981 21.0076 32.0147 21.577 31.844 22.2147C31.6731 22.8532 31.2985 23.5537 30.7471 24.2736C29.6445 25.7132 27.8473 27.2142 25.6151 28.4302C23.3828 29.6462 21.1471 30.3422 19.3396 30.4879C18.4358 30.5607 17.644 30.4955 17.015 30.2929C16.3866 30.0905 15.9264 29.7534 15.6711 29.2847C15.4158 28.8161 15.3821 28.2466 15.5528 27.6089C15.7238 26.9705 16.0983 26.27 16.6497 25.5501C17.7523 24.1105 19.5495 22.6095 21.7818 21.3935C24.014 20.1774 26.2497 19.4814 28.0572 19.3358C28.9611 19.2629 29.7528 19.3281 30.3819 19.5307C31.0102 19.7331 31.4704 20.0703 31.7257 20.5389Z",
    stroke: "white",
    strokeWidth: 0.208877
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2249 28.0287C16.0569 28.5801 16.0693 29.0769 16.291 29.4839C17.2033 31.1585 21.4434 30.9624 25.6016 28.6972C29.7598 26.432 32.2614 22.9555 31.3492 21.2809C31.0699 20.7683 30.4911 20.4575 29.7029 20.3379C29.1797 22.055 26.907 24.3017 23.7595 26.0164C20.8741 27.5882 18.0117 28.2998 16.2249 28.0287Z",
    fill: "#02006E"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.4015,
    cy: 28.2823,
    rx: 1.40133,
    ry: 1.28459,
    transform: "rotate(-29.8315 25.4015 28.2823)",
    fill: "#FFC200"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6779 22.0823L25.9334 27.7209L24.7467 28.406L21.4778 22.7441C21.7033 22.6102 21.9341 22.4788 22.1699 22.3504C22.3394 22.258 22.5088 22.1687 22.6779 22.0823Z",
    fill: "#FFC200"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7912 25.0207L21.4768 22.7441C21.7025 22.6101 21.9334 22.4786 22.1693 22.3501C22.3387 22.2579 22.508 22.1686 22.677 22.0823L23.9601 24.3048C23.6529 24.6466 23.2488 24.8996 22.7912 25.0207Z",
    fill: "#D7A300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsImage);
export default __webpack_public_path__ + "static/media/notifications-image.f0b44f186cc6341df122641a97e1c0ee.svg";
export { ForwardRef as ReactComponent };